export enum UserType {
  Bookkeeper = 'bookkeeper',
  User = 'user',
}
